// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animatedSvgFirstPath {
  0% {
    opacity: 0.4;
  }
  33% {
    opacity: 1;
  }
  66% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.4;
  }
}
@keyframes animatedSvgSecondPath {
  0% {
    opacity: 0.4;
  }
  33% {
    opacity: 0.4;
  }
  66% {
    opacity: 1;
  }
  100% {
    opacity: 0.4;
  }
}
@keyframes animatedSvgThirdPath {
  0% {
    opacity: 1;
  }
  33% {
    opacity: 0.4;
  }
  66% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.GenerateWinninAIReportButton-icon path:nth-child(1),
.GenerateWinninAIReportButton-icon2 path:nth-child(1) {
  animation: animatedSvgFirstPath 2000ms ease-in-out infinite;
}
.GenerateWinninAIReportButton-icon path:nth-child(2),
.GenerateWinninAIReportButton-icon2 path:nth-child(2) {
  animation: animatedSvgSecondPath 2000ms ease-in-out infinite;
}
.GenerateWinninAIReportButton-icon path:nth-child(3),
.GenerateWinninAIReportButton-icon2 path:nth-child(3) {
  animation: animatedSvgThirdPath 2000ms ease-in-out infinite;
}

.GenerateWinninAIReportButton-icon2 {
  fill: #bf13c3 !important;
}

.GenerateWinninAIReportButton-text {
  color: #bf13c3 !important;
  display: none;
}

.GenerateWinninAIReportButton-div {
  justify-self: flex-end;
  min-width: 0px;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/GenerateWinninAIReportButton/index.scss"],"names":[],"mappings":"AAEE;EACE;IACE,YAAA;EADJ;EAGE;IACE,UAAA;EADJ;EAGE;IACE,YAAA;EADJ;EAGE;IACE,YAAA;EADJ;AACF;AAIE;EACE;IACE,YAAA;EAFJ;EAIE;IACE,YAAA;EAFJ;EAIE;IACE,UAAA;EAFJ;EAIE;IACE,YAAA;EAFJ;AACF;AAKE;EACE;IACE,UAAA;EAHJ;EAKE;IACE,YAAA;EAHJ;EAKE;IACE,YAAA;EAHJ;EAKE;IACE,UAAA;EAHJ;AACF;AAME;;EACE,2DAAA;AAHJ;AAME;;EACE,4DAAA;AAHJ;AAME;;EACE,2DAAA;AAHJ;;AAOA;EACE,wBAAA;AAJF;;AAOA;EACE,yBAAA;EACA,aAAA;AAJF;;AAOA;EACE,sBAAA;EACA,cAAA;EACA,mBAAA;AAJF","sourcesContent":[".GenerateWinninAIReportButton-icon,\n.GenerateWinninAIReportButton-icon2 {\n  @keyframes animatedSvgFirstPath {\n    0% {\n      opacity: 0.4;\n    }\n    33% {\n      opacity: 1;\n    }\n    66% {\n      opacity: 0.4;\n    }\n    100% {\n      opacity: 0.4;\n    }\n  }\n\n  @keyframes animatedSvgSecondPath {\n    0% {\n      opacity: 0.4;\n    }\n    33% {\n      opacity: 0.4;\n    }\n    66% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0.4;\n    }\n  }\n\n  @keyframes animatedSvgThirdPath {\n    0% {\n      opacity: 1;\n    }\n    33% {\n      opacity: 0.4;\n    }\n    66% {\n      opacity: 0.4;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n  path:nth-child(1) {\n    animation: animatedSvgFirstPath 2000ms ease-in-out infinite;\n  }\n\n  path:nth-child(2) {\n    animation: animatedSvgSecondPath 2000ms ease-in-out infinite;\n  }\n\n  path:nth-child(3) {\n    animation: animatedSvgThirdPath 2000ms ease-in-out infinite;\n  }\n}\n\n.GenerateWinninAIReportButton-icon2 {\n  fill: #bf13c3 !important;\n}\n\n.GenerateWinninAIReportButton-text {\n  color: #bf13c3 !important;\n  display: none;\n}\n\n.GenerateWinninAIReportButton-div {\n  justify-self: flex-end;\n  min-width: 0px;\n  white-space: nowrap;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
